import { NgModule }                    from '@angular/core';
import { ModalBaseModule }             from '@core/modal-base/modal-base.module';
import { SelectVersionModalComponent } from '@core/modals/select-version-modal/select-version-modal.component';
import { SharedModule }                from '@shared/shared.module';


@NgModule( {
	declarations: [
		SelectVersionModalComponent
	],
	exports: [
		SelectVersionModalComponent
	],
	imports: [
		// Shared,
		SharedModule,

		// Modal Base
		ModalBaseModule
	]
} )
export class SelectVersionModalModule {}
